import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";
import SectionHeader from "../components/SectionHeader";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AOS from "aos";
import "aos/dist/aos.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import img_3 from "../assets/1.jpg";
import img_4 from "../assets/2.jpg";
import img_5 from "../assets/3.jpg";
import img_6 from "../assets/4.jpg";
import img_7 from "../assets/5.jpg";
import img_8 from "../assets/6.jpg";
import img_9 from "../assets/7.jpg";
import img_10 from "../assets/8.jpg";
import img_11 from "../assets/9.jpg";
import img_12 from "../assets/10.jpg";
import img_13 from "../assets/11.jpg";
import img_14 from "../assets/12.jpg";
import img_15 from "../assets/13.jpg";
import img_16 from "../assets/14.jpg";
import img_18 from "../assets/15.jpg";
import img_19 from "../assets/16.jpg";
import img_20 from "../assets/17.jpg";
import img_21 from "../assets/18.jpg";
import img_22 from "../assets/19.jpg";
import img_23 from "../assets/20.jpg";
import img_24 from "../assets/21.jpg";
import img_25 from "../assets/22.jpg";
import img_26 from "../assets/23.jpg";
import img_27 from "../assets/25.jpg";
import img_28 from "../assets/26.jpg";
import img_29 from "../assets/27.jpg";
import img_30 from "../assets/28.jpg";
import img_31 from "../assets/29.jpg";
import img_32 from "../assets/30.jpg";
import img_33 from "../assets/31.jpg";

// Custom Next Arrow
function NextArrow({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="absolute -right-4 sm:-right-6 md:-right-12 top-1/2 -translate-y-1/2 z-20 
                 bg-red-600 hover:bg-red-700 text-white rounded-full p-2 sm:p-3 md:p-4 shadow-lg transition-all"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );
}

// Custom Prev Arrow
function PrevArrow({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="absolute -left-4 sm:-left-6 md:-left-12 top-1/2 -translate-y-1/2 z-20 
                 bg-red-600 hover:bg-red-700 text-white rounded-full p-2 sm:p-3 md:p-4 shadow-lg transition-all"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
  );
}

function Gallary() {
  const { texts } = useContext(LanguageContext);

  let images = [
    { src: img_3 },
    { src: img_4 },
    { src: img_5 },
    { src: img_6 },
    { src: img_7 },
    { src: img_8 },
    { src: img_9 },
    { src: img_10 },
    { src: img_11 },
    { src: img_12 },
    { src: img_13 },
    { src: img_14 },
    { src: img_15 },
    { src: img_16 },
    { src: img_18 },
    { src: img_19 },
    { src: img_20 },
    { src: img_21 },
    { src: img_22 },
    { src: img_23 },
    { src: img_24 },
    { src: img_25 },
    { src: img_26 },
    { src: img_27 },
    { src: img_28 },
    { src: img_29 },
    { src: img_30 },
    { src: img_31 },
    { src: img_32 },
    { src: img_33 },
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  const settings = {
    className: "center gallery-slider",
    dots: true,
    centerMode: true,
    centerPadding: "80px",
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 3, centerPadding: "60px" },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, centerPadding: "50px" },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerPadding: "30px",
          autoplaySpeed: 4000,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
          autoplaySpeed: 4000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
          autoplaySpeed: 4000,
        },
      },
    ],
  };

  const [index, setIndex] = useState(-1);
  const [isOpen, setModalOpen] = useState(false);

  const setIsOpen = (state, i) => {
    setIndex(i);
    setModalOpen(state);
  };

  return (
    <section
      id="projects"
      className="relative bg-gradient-to-b from-white via-neutral-50 to-neutral-100 py-16 sm:py-20 lg:py-28 overflow-hidden scroll-mt-20 sm:scroll-mt-24"
      data-aos="fade-in"
      data-aos-duration="1000"
    >
      {/* Enhanced Background Pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 -left-40 w-80 h-80 bg-primary-200 rounded-full opacity-10 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 -right-40 w-96 h-96 bg-primary-300 rounded-full opacity-10 blur-3xl animate-pulse animation-delay-1000"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(139,0,0,0.02),transparent_50%)]"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 sm:pt-12">
        {/* Enhanced Header Section */}
        <SectionHeader
          badgeText={texts.badge_our_showcase}
          badgeIcon={
            <svg className="w-4 h-4 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          }
          title={texts.gallary}
          titleAs="h1"
          subtitle={texts.gallary_subtitle}
          titleClassName="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-3 sm:mb-4 md:mb-5"
          subtitleClassName="max-w-3xl px-4"
          decorativeLineClassName="mb-4"
        />

        {/* Gallery Slider */}
        <div
          className="gallery-container px-4 sm:px-8 lg:px-16 mb-20 sm:mb-24 lg:mb-32"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="400"
        >
          <Slider {...settings}>
            {images.map((item, i) => (
              <div 
                key={i} 
                className="px-1 sm:px-2"
                data-aos="zoom-in"
                data-aos-duration="600"
                data-aos-delay={i * 100 + 600}
              >
                <div className="group relative overflow-hidden rounded-2xl sm:rounded-3xl shadow-medium hover:shadow-2xl transition-all duration-500">
                  {/* Image Container */}
                  <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl aspect-[4/4]">
                    <img
                      src={item.src}
                      alt={`Gallery image ${i + 1}`}
                      onClick={() => setIsOpen(true, i)}
                      className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:rotate-1 cursor-pointer"
                      loading="lazy"
                    />
                    {/* Enhanced Multi-layer Overlay */}
                    <div
                      className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
                      onClick={() => setIsOpen(true, i)}
                    ></div>
                    <div
                      className="absolute inset-0 bg-gradient-to-br from-primary-600/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer"
                      onClick={() => setIsOpen(true, i)}
                    ></div>
                    
                    {/* Hover Icon with enhanced design */}
                    <div
                      className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-50 group-hover:scale-100 cursor-pointer"
                      onClick={() => setIsOpen(true, i)}
                    >
                      <div className="relative">
                        <div className="absolute inset-0 bg-white/30 blur-xl rounded-full"></div>
                        <div className="relative bg-white/95 backdrop-blur-md rounded-full p-4 sm:p-5 border-2 border-white shadow-2xl">
                          <svg
                            className="w-6 h-6 sm:w-7 sm:h-7 text-primary-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2.5}
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    
                    {/* Image counter badge */}
                    <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {i + 1} / {images.length}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Enhanced View All Button */}
        <div 
          className="text-center"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="800"
        >
          <button
            onClick={() => setIsOpen(true, 0)}
            className="group/btn relative inline-flex items-center gap-3 overflow-hidden bg-gradient-to-r from-primary-400 via-primary-500 to-primary-600 hover:from-primary-500 hover:via-primary-600 hover:to-primary-700 text-white font-bold px-8 sm:px-12 py-4 sm:py-5 rounded-2xl shadow-large hover:shadow-2xl transition-all duration-500 transform hover:scale-110 text-sm sm:text-base md:text-lg"
          >
            <span className="relative z-10">View Full Gallery</span>
            <svg
              className="relative z-10 w-5 h-5 transition-transform duration-300 group-hover/btn:translate-x-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
            {/* Animated shine effect */}
            <div className="absolute inset-0 -translate-x-full group-hover/btn:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12"></div>
          </button>
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        index={index}
        slides={images}
        open={isOpen}
        plugins={[Fullscreen, Slideshow, Thumbnails, Video, Zoom]}
        close={() => setIsOpen(false)}
        styles={{
          container: { backgroundColor: "rgba(0, 0, 0, 0.95)" },
          thumbnail: { borderColor: "#8B0000", borderWidth: "2px" },
        }}
      />

      <style jsx>{`
        .gallery-slider {
          margin-bottom: 80px;
        }
        
        .gallery-slider .slick-dots {
          bottom: -70px;
        }
        
        .gallery-slider .slick-dots li {
          margin: 0 2px;
        }
        
        .gallery-slider .slick-dots li button:before {
          font-size: 10px;
          color: #8b0000;
          opacity: 0.5;
        }
        
        .gallery-slider .slick-dots li.slick-active button:before {
          opacity: 1;
          color: #8b0000;
        }

        /* Mobile specific styles */
        @media (max-width: 640px) {
          .gallery-slider {
            margin-bottom: 60px;
          }
          
          .gallery-slider .slick-dots {
            bottom: -50px;
          }
          
          .gallery-slider .slick-dots li button:before {
            font-size: 8px;
          }
        }

        /* Extra small mobile devices */
        @media (max-width: 480px) {
          .gallery-slider .slick-dots {
            bottom: -45px;
          }
          
          .gallery-slider .slick-dots li {
            margin: 0 1px;
          }
        }
      `}</style>
    </section>
  );
}

export default Gallary;